/**
 * Shared pagination types for cursor-based infinite scroll
 */

export const FEED_PAGE_SIZE = 15

export interface CursorParams {
  cursor?: string // ISO timestamp of last item
  cursorId?: string // ID of last item (tiebreaker)
  limit: number
  search?: string
  sentiment?: 'bullish' | 'bearish' | 'neutral'
}

export interface PaginatedResult<T> {
  data: T[]
  nextCursor: string | null
  nextCursorId: string | null
  hasMore: boolean
}
